var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 49,
    viewBox: "0 0 161 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_21763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.182 48.5588H6.36201C3.10997 48.5588 0.449219 45.8723 0.449219 42.5887V6.76779C0.449219 3.48421 3.10997 0.797642 6.36201 0.797642H154.182C157.434 0.797642 160.094 3.48421 160.094 6.76779V42.5887C160.094 45.8723 157.434 48.5588 154.182 48.5588Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5254 13.0285C56.5254 14.0289 56.232 14.8255 55.6444 15.4198C54.977 16.1264 54.1071 16.48 53.0377 16.48C52.0136 16.48 51.1429 16.1218 50.4269 15.4044C49.7095 14.6875 49.3516 13.7985 49.3516 12.7379C49.3516 11.6768 49.7095 10.7883 50.4269 10.0709C51.1429 9.35401 52.0136 8.99532 53.0377 8.99532C53.5459 8.99532 54.0324 9.09562 54.4943 9.29574C54.9562 9.49634 55.3267 9.76261 55.6039 10.0961L54.9802 10.7262C54.5105 10.1595 53.8637 9.8764 53.0377 9.8764C52.2908 9.8764 51.645 10.1414 51.1 10.6716C50.5548 11.2025 50.2823 11.8908 50.2823 12.7379C50.2823 13.5849 50.5548 14.2733 51.1 14.8042C51.645 15.3344 52.2908 15.5994 53.0377 15.5994C53.83 15.5994 54.4906 15.333 55.0194 14.7995C55.3627 14.4519 55.5613 13.9688 55.6144 13.3484H53.0377V12.4879H56.476C56.5092 12.675 56.5254 12.8545 56.5254 13.0285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5226 13.0285H56.4043C56.4034 14.006 56.1206 14.7653 55.558 15.3354L55.5567 15.3363L55.5562 15.3373C54.9099 16.0195 54.0793 16.3591 53.0349 16.3606C52.0381 16.3591 51.2038 16.0158 50.5072 15.32C49.812 14.6226 49.4683 13.7714 49.467 12.7379C49.4683 11.7038 49.812 10.8531 50.5072 10.1563C51.2038 9.4599 52.0381 9.11614 53.0349 9.11471C53.5278 9.11471 53.9971 9.21178 54.4447 9.40533C54.8928 9.60032 55.2467 9.85584 55.5104 10.1731L55.601 10.0961L55.5174 10.0117L54.8937 10.6422L54.9773 10.7262L55.0684 10.6498C54.5768 10.055 53.8868 9.75519 53.0349 9.75698C52.2603 9.75602 51.5789 10.0354 51.0153 10.5859C50.4463 11.1381 50.1603 11.8652 50.1613 12.7379C50.1603 13.6106 50.4463 14.3376 51.0153 14.8899C51.5789 15.4403 52.2603 15.7197 53.0349 15.7188C53.8534 15.7202 54.551 15.4398 55.1002 14.8839C55.467 14.5126 55.6749 13.9982 55.7294 13.3586L55.7404 13.229H53.1531V12.6072H56.4732V12.4878L56.3567 12.5089C56.3891 12.6899 56.4043 12.8619 56.4043 13.0285H56.5226H56.6409C56.6409 12.847 56.6242 12.6605 56.5895 12.4665L56.572 12.3684H52.9166V13.3484V13.4678H55.6115V13.3484L55.4938 13.3381C55.4416 13.9389 55.2522 14.3914 54.933 14.7151C54.4249 15.2262 53.8013 15.4785 53.0349 15.48C52.3156 15.479 51.7054 15.229 51.1793 14.7183C50.6583 14.2094 50.3991 13.5597 50.3978 12.7379C50.3991 11.916 50.6583 11.2663 51.1793 10.7575C51.7054 10.2468 52.3156 9.99674 53.0349 9.99578C53.8345 9.99769 54.4383 10.2644 54.8869 10.8032L54.97 10.903L55.6846 10.1805L55.7613 10.1031L55.6915 10.0195C55.4009 9.66981 55.0139 9.3922 54.538 9.18611C54.0613 8.97942 53.5583 8.8759 53.0349 8.8759C51.9836 8.87495 51.0763 9.24808 50.3404 9.98647C49.6018 10.7234 49.2295 11.6498 49.2305 12.7379C49.2295 13.8255 49.6018 14.7523 50.3409 15.4898C51.0763 16.2277 51.9836 16.6003 53.0349 16.5994C54.1297 16.6003 55.0379 16.2332 55.7271 15.5023L55.6416 15.4198L55.7252 15.5042C56.3378 14.8862 56.6417 14.0513 56.6409 13.0285H56.5226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9742 10.036H58.743V12.3075H61.6569V13.1684H58.743V15.4399H61.9742V16.3201H57.832V9.15589H61.9742V10.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9752 10.036V9.91659H58.6258V12.4269H61.5397V13.0486L58.6258 13.049V15.5593H61.857V16.2006H57.9514V9.27527H61.857V10.036H61.9752V9.91659V10.036H62.0935V9.15587V9.03647H57.7148V16.4395H62.0935V15.4399V15.3205H58.8623V13.2878H61.7762V12.3075V12.1881H58.8623V10.1554H62.0935V10.036H61.9752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8199 16.3201H64.9075V10.036H62.9258V9.15589H67.8016V10.036H65.8199V16.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8209 16.3201V16.2006H65.0268V9.91659H63.0451V9.27527H67.6844V9.91659H65.7027V16.3201H65.8209V16.2006V16.3201H65.9392V10.1554H67.9209V9.15587V9.03647H62.8086V10.036V10.1554H64.7903V16.4395H65.8209H65.9392V16.3201H65.8209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3281 16.3201V9.15589H72.2395V16.3201H71.3281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3292 16.3201H71.4474V9.27527H72.1223V16.2006H71.3292V16.3201H71.4474H71.3292V16.4395H72.2406H72.3588V9.03647H71.3292H71.2109V16.4395H71.3292V16.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2846 16.3201H75.3722V10.036H73.3906V9.15589H78.2663V10.036H76.2846V16.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2856 16.3201V16.2006H75.4916V9.91659H73.5099V9.27527H78.1491V9.91659H76.1674V16.3201H76.2856V16.2006V16.3201H76.4039V10.1554H78.3856V9.15587V9.03647H73.2734V10.036V10.1554H75.255V16.4395H76.2856H76.4039V16.3201H76.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9684 14.7944C83.4935 15.3312 84.1361 15.5994 84.896 15.5994C85.656 15.5994 86.2989 15.3312 86.8233 14.7944C87.3489 14.2575 87.6123 13.5713 87.6123 12.7379C87.6123 11.9045 87.3489 11.2182 86.8233 10.6814C86.2989 10.1446 85.656 9.8764 84.896 9.8764C84.1361 9.8764 83.4935 10.1446 82.9684 10.6814C82.444 11.2182 82.1808 11.9045 82.1808 12.7379C82.1808 13.5713 82.444 14.2575 82.9684 14.7944ZM87.4977 15.3941C86.8001 16.1184 85.9326 16.48 84.896 16.48C83.8585 16.48 82.9914 16.1184 82.2954 15.3941C81.5973 14.6707 81.25 13.7851 81.25 12.7379C81.25 11.6907 81.5973 10.805 82.2954 10.0817C82.9914 9.35723 83.8585 8.99532 84.896 8.99532C85.9271 8.99532 86.7923 9.35914 87.4931 10.0863C88.1929 10.8135 88.5431 11.6973 88.5431 12.7379C88.5431 13.7851 88.1937 14.6707 87.4977 15.3941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9655 14.7943L82.8815 14.8783C83.4261 15.4366 84.1056 15.7202 84.8932 15.7188C85.6803 15.7202 86.3608 15.4366 86.9045 14.8783C87.4528 14.3195 87.7285 13.5965 87.7277 12.7379C87.7285 11.8792 87.4528 11.1563 86.9045 10.5975C86.3608 10.0391 85.6803 9.75554 84.8932 9.75698C84.1056 9.75554 83.4261 10.0391 82.8815 10.5975C82.3345 11.1563 82.0583 11.8792 82.0597 12.7379C82.0583 13.5965 82.3345 14.3195 82.8815 14.8783L82.9655 14.7943L83.0496 14.7104C82.548 14.1949 82.2972 13.5466 82.2962 12.7379C82.2972 11.9292 82.548 11.2808 83.0496 10.7653C83.5559 10.25 84.1605 9.99721 84.8932 9.99578C85.6253 9.99721 86.2314 10.25 86.7364 10.7653C87.2389 11.2808 87.4898 11.9292 87.4907 12.7379C87.4898 13.5466 87.2389 14.1949 86.7364 14.7104C86.2314 15.2258 85.6253 15.4785 84.8932 15.48C84.1605 15.4785 83.5559 15.2258 83.0496 14.7104L82.9655 14.7943ZM87.4949 15.3941L87.4103 15.3111C86.7322 16.0126 85.903 16.3591 84.8932 16.3606C83.883 16.3591 83.0538 16.0126 82.377 15.3111L82.3738 15.3074L82.377 15.3111C81.7003 14.6072 81.3664 13.7584 81.3654 12.7379C81.3664 11.7173 81.7003 10.8685 82.377 10.1646C83.0538 9.46313 83.883 9.11614 84.8932 9.11471C85.8965 9.11614 86.7238 9.46456 87.4057 10.1698C88.0847 10.8769 88.4206 11.7244 88.422 12.7379C88.4206 13.7584 88.0857 14.6072 87.4103 15.3111L87.4949 15.3941L87.5799 15.4771C88.2967 14.7337 88.6593 13.8115 88.6585 12.7379C88.6593 11.6703 88.2953 10.75 87.5751 10.0033C86.8546 9.25369 85.952 8.87459 84.8932 8.8759C83.8289 8.87459 82.9236 9.2519 82.2075 9.99865V9.99817C81.4892 10.742 81.128 11.6642 81.1289 12.7379C81.128 13.8115 81.4892 14.7337 82.2075 15.4776L82.2107 15.4809L82.2075 15.4771C82.9236 16.2238 83.8289 16.6003 84.8932 16.5994C85.9571 16.6003 86.8624 16.2238 87.5799 15.4771L87.4949 15.3941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8203 16.3201V9.15589H90.9299L94.3782 14.7291H94.4175L94.3782 13.3485V9.15589H95.2906V16.3201H94.339L90.7312 10.4767H90.692L90.7312 11.8579V16.3201H89.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8214 16.3201H89.9396V9.27527H90.8653L94.3137 14.8485H94.4186H94.54L94.4976 13.3467V9.27527H95.1734V16.2006H94.4057L90.7979 10.3573H90.693H90.5716L90.614 11.8598V16.2006H89.8214V16.3201H89.9396H89.8214V16.4395H90.7323H90.8506V11.8559L90.8113 10.4735L90.693 10.4767V10.5961H90.7323V10.4767L90.632 10.5402L94.2744 16.4395H95.2917H95.4099V9.03647H94.3793H94.261V13.3499L94.3003 14.7323L94.4186 14.7291V14.6097H94.3793V14.7291L94.4796 14.6657L90.9965 9.03647H89.8214H89.7031V16.4395H89.8214V16.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.908 36.6185H129.115V21.6917H126.908V36.6185ZM146.783 27.0686L144.254 33.5402H144.178L141.553 27.0686H139.176L143.113 36.1138L140.868 41.1451H143.171L149.237 27.0686H146.783ZM134.269 34.9231C133.546 34.9231 132.538 34.5583 132.538 33.6554C132.538 32.5033 133.794 32.0616 134.877 32.0616C135.848 32.0616 136.303 32.2728 136.894 32.5612C136.722 33.9436 135.543 34.9231 134.269 34.9231ZM134.536 26.7421C132.938 26.7421 131.284 27.4529 130.599 29.0276L132.557 29.8531C132.976 29.0276 133.755 28.7584 134.573 28.7584C135.715 28.7584 136.875 29.4501 136.894 30.6791V30.8326C136.494 30.6021 135.639 30.2566 134.592 30.2566C132.481 30.2566 130.332 31.4277 130.332 33.6171C130.332 35.6143 132.063 36.9011 134.002 36.9011C135.486 36.9011 136.303 36.229 136.818 35.4418H136.894V36.5938H139.023V30.8708C139.023 28.2211 137.065 26.7421 134.536 26.7421ZM120.898 28.8857H117.76V23.7692H120.898C122.548 23.7692 123.485 25.1483 123.485 26.3274C123.485 27.4842 122.548 28.8857 120.898 28.8857ZM120.842 21.6917H115.554V36.6185H117.76V30.9632H120.842C123.287 30.9632 125.691 29.1754 125.691 26.3274C125.691 23.4795 123.287 21.6917 120.842 21.6917ZM92.0096 34.9258C90.4852 34.9258 89.2088 33.6371 89.2088 31.8671C89.2088 30.0784 90.4852 28.7701 92.0096 28.7701C93.5146 28.7701 94.6958 30.0784 94.6958 31.8671C94.6958 33.6371 93.5146 34.9258 92.0096 34.9258ZM94.5434 27.9045H94.4671C93.9719 27.3083 93.0189 26.7697 91.8189 26.7697C89.304 26.7697 86.999 29.0009 86.999 31.8671C86.999 34.7141 89.304 36.9263 91.8189 36.9263C93.0189 36.9263 93.9719 36.3876 94.4671 35.7724H94.5434V36.5033C94.5434 38.4464 93.5146 39.4851 91.8572 39.4851C90.5046 39.4851 89.6662 38.5037 89.3229 37.6768L87.399 38.4846C87.9515 39.8311 89.4186 41.4856 91.8572 41.4856C94.4482 41.4856 96.6391 39.9464 96.6391 36.1954V27.0775H94.5434V27.9045ZM98.163 36.6185H100.373V21.6912H98.163V36.6185ZM103.631 31.6941C103.574 29.7318 105.136 28.7318 106.26 28.7318C107.137 28.7318 107.88 29.174 108.127 29.8093L103.631 31.6941ZM110.489 30.0014C110.071 28.8661 108.794 26.7697 106.184 26.7697C103.593 26.7697 101.44 28.8279 101.44 31.848C101.44 34.695 103.574 36.9263 106.431 36.9263C108.737 36.9263 110.071 35.5028 110.623 34.6758L108.908 33.5214C108.337 34.368 107.556 34.9258 106.431 34.9258C105.307 34.9258 104.507 34.4063 103.993 33.3871L110.718 30.5784L110.489 30.0014ZM56.9099 28.3279V30.4823H62.0156C61.8631 31.6941 61.4631 32.5788 60.8533 33.1945C60.1106 33.9449 58.9484 34.7719 56.9099 34.7719C53.7663 34.7719 51.3088 32.2136 51.3088 29.0396C51.3088 25.8657 53.7663 23.307 56.9099 23.307C58.6055 23.307 59.8436 23.9804 60.7582 24.8461L62.2632 23.3265C60.9869 22.0951 59.2911 21.1526 56.9099 21.1526C52.6041 21.1526 48.9844 24.6922 48.9844 29.0396C48.9844 33.3871 52.6041 36.9263 56.9099 36.9263C59.2343 36.9263 60.9869 36.1572 62.3584 34.7141C63.7682 33.2906 64.2066 31.2901 64.2066 29.6745C64.2066 29.174 64.1686 28.7127 64.092 28.3279H56.9099ZM70.0113 34.9258C68.4869 34.9258 67.1722 33.6562 67.1722 31.848C67.1722 30.0205 68.4869 28.7701 70.0113 28.7701C71.5352 28.7701 72.8498 30.0205 72.8498 31.848C72.8498 33.6562 71.5352 34.9258 70.0113 34.9258ZM70.0113 26.7697C67.2295 26.7697 64.9623 28.9048 64.9623 31.848C64.9623 34.7719 67.2295 36.9263 70.0113 36.9263C72.7926 36.9263 75.0598 34.7719 75.0598 31.848C75.0598 28.9048 72.7926 26.7697 70.0113 26.7697ZM81.0247 34.9258C79.5009 34.9258 78.1861 33.6562 78.1861 31.848C78.1861 30.0205 79.5009 28.7701 81.0247 28.7701C82.5487 28.7701 83.8633 30.0205 83.8633 31.848C83.8633 33.6562 82.5487 34.9258 81.0247 34.9258ZM81.0247 26.7697C78.243 26.7697 75.9763 28.9048 75.9763 31.848C75.9763 34.7719 78.243 36.9263 81.0247 36.9263C83.8061 36.9263 86.0733 34.7719 86.0733 31.848C86.0733 28.9048 83.8061 26.7697 81.0247 26.7697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8773 39.4717L12.7895 39.3868C12.4453 39.0191 12.2422 38.4483 12.2422 37.7091V37.883V11.4759C12.2422 11.4735 12.2422 11.4717 12.2422 11.4698C12.2422 11.472 12.2422 11.4739 12.2422 11.4763V11.6508C12.2422 10.8503 12.4791 10.2473 12.8759 9.88577L27.5276 24.6792L12.8773 39.4717ZM12.2422 11.4683C12.2422 11.4025 12.244 11.3387 12.2473 11.2757C12.244 11.3382 12.2422 11.4025 12.2422 11.4683ZM12.2473 11.2729C12.2473 11.272 12.2473 11.2711 12.2476 11.2701C12.2473 11.2711 12.2473 11.272 12.2473 11.2729ZM12.2476 11.2645C12.2476 11.264 12.2476 11.2636 12.2476 11.2631C12.2476 11.2636 12.2476 11.264 12.2476 11.2645Z",
    fill: "url(#paint0_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4105 29.7869L32.5219 29.723L38.308 26.4035C38.8597 26.0868 39.2273 25.7029 39.4107 25.2967C39.2278 25.7029 38.86 26.0873 38.308 26.4039L32.5219 29.7235L32.4105 29.7869ZM32.4119 29.6119L27.5273 24.6792L32.4114 19.7472L38.308 23.1297C39.0568 23.5593 39.4772 24.113 39.5474 24.6787C39.5474 24.6792 39.5474 24.6801 39.5474 24.681C39.4772 25.2454 39.0568 25.7995 38.308 26.229L32.4119 29.6119Z",
    fill: "url(#paint1_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9217 40.0349C13.5124 40.0349 13.1553 39.9006 12.8768 39.6469L12.8773 39.6464C13.1558 39.9001 13.5134 40.0349 13.9227 40.0349C13.9581 40.0349 13.9942 40.034 14.0308 40.0322C13.9937 40.034 13.9572 40.0349 13.9217 40.0349ZM13.9222 39.86C13.5129 39.8605 13.1558 39.7257 12.8773 39.4719V39.4716L27.5275 24.6791L32.4121 29.6119L15.247 39.4594C14.7721 39.7313 14.3221 39.86 13.9222 39.86ZM12.8732 39.6436C12.8473 39.6199 12.8218 39.5947 12.7969 39.5685L12.8732 39.6436Z",
    fill: "url(#paint2_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5266 24.6792L12.875 9.88577C13.1535 9.63251 13.5102 9.49819 13.919 9.49819C14.32 9.49819 14.7703 9.62738 15.2461 9.89974L32.4107 19.7473L27.5266 24.6792ZM32.5212 19.6359L15.2461 9.72541C14.7703 9.45293 14.32 9.32374 13.919 9.32374C13.9171 9.32374 13.9158 9.32374 13.9139 9.32374C13.9162 9.32374 13.918 9.32374 13.9209 9.32374C14.3209 9.32374 14.7708 9.45245 15.2461 9.72493L32.5212 19.6359Z",
    fill: "url(#paint3_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0304 40.0322C14.4022 40.0107 14.8138 39.8815 15.2467 39.6339L32.4103 29.7869L15.2467 39.6339C14.8142 39.882 14.4022 40.0107 14.0304 40.0322ZM12.8765 39.6469L12.8728 39.6437C12.8741 39.6446 12.8755 39.646 12.8765 39.6469ZM12.7965 39.5686L12.7891 39.5612V39.5607C12.7919 39.5635 12.7941 39.5662 12.7965 39.5686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4102 29.7869L32.5216 29.7236L32.4102 29.7869Z",
    fill: "url(#paint4_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9223 40.0349C13.513 40.0349 13.1554 39.9001 12.8769 39.6464L12.8765 39.6469C12.8755 39.6459 12.8741 39.6446 12.8728 39.6436L12.7965 39.5685C12.7941 39.5661 12.7919 39.5634 12.7891 39.5606L12.8769 39.4719C13.1554 39.7257 13.5126 39.8605 13.9218 39.86C14.3218 39.86 14.7717 39.7313 15.2467 39.4594L32.4117 29.6119L32.5217 29.7229L32.4103 29.7868L15.2467 39.6338C14.8138 39.8815 14.4022 40.0107 14.0304 40.0322C13.9939 40.034 13.9578 40.0349 13.9223 40.0349Z",
    fill: "url(#paint5_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7895 39.5613C12.4453 39.1936 12.2422 38.6228 12.2422 37.8835V37.8831C12.2422 38.6228 12.4453 39.1932 12.7895 39.5608V39.5613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7895 39.5608C12.4454 39.1931 12.2422 38.6228 12.2422 37.8831V37.7091C12.2422 38.4483 12.4454 39.0192 12.7895 39.3868L12.8773 39.4717L12.7895 39.5608Z",
    fill: "url(#paint6_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7891 39.5608L12.8769 39.4726V39.4729L12.7891 39.5608Z",
    fill: "url(#paint7_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4102 25.2966C39.5011 25.0951 39.5469 24.888 39.5469 24.6809C39.5469 24.6805 39.5469 24.68 39.5469 24.68C39.5469 24.8876 39.5011 25.0946 39.4102 25.2966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 29.7229L32.4141 29.6119L38.3102 26.2289C39.059 25.7994 39.4794 25.2453 39.5496 24.6809C39.5496 24.888 39.5038 25.0951 39.4129 25.2966C39.2295 25.7028 38.8618 26.0867 38.3102 26.4034L32.524 29.7229Z",
    fill: "url(#paint8_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5495 24.6792V24.6787C39.549 24.0541 39.1356 23.4296 38.31 22.9557L32.5239 19.6362H32.5234L32.5239 19.6359L38.31 22.9553C39.1365 23.4292 39.5504 24.0546 39.5495 24.6792Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5462 24.6787C39.4759 24.113 39.0555 23.5593 38.3067 23.1297L32.4102 19.7473L32.5201 19.6362H32.5206L38.3067 22.9557C39.1323 23.4296 39.5457 24.0541 39.5462 24.6787Z",
    fill: "url(#paint9_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2422 11.4697C12.2422 11.4692 12.2422 11.4688 12.2422 11.4683C12.2422 11.4688 12.2422 11.4692 12.2422 11.4697ZM12.2473 11.2757C12.2473 11.2747 12.2473 11.2738 12.2473 11.2728C12.2473 11.2738 12.2473 11.2747 12.2473 11.2757ZM12.2476 11.2701C12.2476 11.2682 12.2476 11.2664 12.2476 11.2645C12.2476 11.2664 12.2476 11.2682 12.2476 11.2701ZM12.2476 11.263C12.3161 10.0364 12.9767 9.32788 13.9111 9.3237C13.506 9.32609 13.1531 9.46042 12.8769 9.71176V9.71128L12.8736 9.71462C12.8445 9.74113 12.8168 9.76919 12.7895 9.79809C12.4791 10.1297 12.2832 10.6264 12.2476 11.263Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2422 11.6506V11.4762C12.2422 11.4738 12.2422 11.4719 12.2422 11.4696C12.2422 11.4691 12.2422 11.4687 12.2422 11.4682C12.2422 11.4024 12.244 11.338 12.2473 11.2756C12.2473 11.2746 12.2473 11.2737 12.2473 11.2727C12.2473 11.2719 12.2473 11.2709 12.2476 11.27C12.2476 11.2681 12.2476 11.2663 12.2476 11.2644C12.2476 11.2639 12.2476 11.2634 12.2476 11.2629C12.2832 10.6263 12.4791 10.1296 12.7895 9.79798L12.8759 9.88562C12.4791 10.2472 12.2422 10.8502 12.2422 11.6506ZM12.8736 9.71451L12.8769 9.71117C12.8759 9.7126 12.8745 9.71356 12.8736 9.71451Z",
    fill: "url(#paint10_linear_716_21763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4112 19.7471L15.2467 9.89955C14.7708 9.62719 14.3205 9.49799 13.9195 9.49799C13.5107 9.49799 13.154 9.63232 12.8755 9.88558L12.7891 9.79793C12.8164 9.76904 12.8441 9.74098 12.8731 9.71447C12.8741 9.71352 12.8755 9.71256 12.8765 9.71161C13.1527 9.46026 13.5056 9.32593 13.9107 9.32355C13.9117 9.32355 13.913 9.32355 13.9144 9.32355C13.9163 9.32355 13.9176 9.32355 13.9195 9.32355C14.3205 9.32355 14.7708 9.45274 15.2467 9.72522L32.5217 19.6357L32.5212 19.636L32.4112 19.7471Z",
    fill: "url(#paint11_linear_716_21763)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_716_21763",
    x1: 26.2284,
    y1: 11.1973,
    x2: 6.19054,
    y2: 31.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_716_21763",
    x1: 40.4598,
    y1: 24.6799,
    x2: 11.8455,
    y2: 24.6799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_716_21763",
    x1: 29.8082,
    y1: 27.4197,
    x2: 2.63537,
    y2: 54.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_716_21763",
    x1: 9.07745,
    y1: 1.00804,
    x2: 21.2112,
    y2: 13.0252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_716_21763",
    x1: 40.4595,
    y1: 24.7291,
    x2: 11.8451,
    y2: 24.7291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_716_21763",
    x1: 29.8078,
    y1: 27.4197,
    x2: 2.63501,
    y2: 54.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_716_21763",
    x1: 26.2284,
    y1: 11.1973,
    x2: 6.19057,
    y2: 31.0427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_716_21763",
    x1: 29.8084,
    y1: 27.5367,
    x2: 2.89572,
    y2: 54.4505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_716_21763",
    x1: 40.462,
    y1: 24.6798,
    x2: 11.8476,
    y2: 24.6798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_716_21763",
    x1: 40.4585,
    y1: 24.6799,
    x2: 11.8442,
    y2: 24.6799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_716_21763",
    x1: 26.2284,
    y1: 11.1971,
    x2: 6.19054,
    y2: 31.0425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_716_21763",
    x1: 9.07796,
    y1: 1.00784,
    x2: 21.2117,
    y2: 13.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_21763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 48,
    fill: "white",
    transform: "translate(0.332031 0.678223)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.02ebeac482fac2663112c25ce9d092de.svg";
export { ForwardRef as ReactComponent };